import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiBookmark, FiLogOut } from 'react-icons/fi';

export const initialOf = (user) => (user?.displayName || user?.email || 'U').charAt(0).toUpperCase();

const TopBar = ({ user, onLogin, onLogout, onSaved, onHome }) => {
    const [open, setOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const closeOnOutside = (e) => {
            if (!menuRef.current?.contains(e.target)) setOpen(false);
        };
        document.addEventListener('pointerdown', closeOnOutside);
        return () => document.removeEventListener('pointerdown', closeOnOutside);
    }, [open]);

    return (
        <header className="ig-topbar">
            <div className="ig-topbar-inner">
                <Link className="ig-wordmark" to="/" onClick={onHome} aria-label="Pinkwire home">pinkwire</Link>
                {user ? (
                    <div className="ig-menu" ref={menuRef}>
                        <button
                            type="button"
                            className="ig-user-chip"
                            onClick={() => setOpen((o) => !o)}
                            aria-haspopup="menu"
                            aria-expanded={open}
                            aria-label="Account menu"
                        >
                            {initialOf(user)}
                        </button>
                        {open && (
                            <ul className="ig-menu-list" role="menu">
                                <li>
                                    <button type="button" role="menuitem" onClick={() => { setOpen(false); onSaved(); }}>
                                        <FiBookmark aria-hidden="true" /> Saved
                                    </button>
                                </li>
                                <li>
                                    <button type="button" role="menuitem" onClick={() => { setOpen(false); onLogout(); }}>
                                        <FiLogOut aria-hidden="true" /> Log out
                                    </button>
                                </li>
                            </ul>
                        )}
                    </div>
                ) : (
                    <button type="button" className="ig-btn ig-btn--primary ig-btn--sm" onClick={onLogin}>Log in</button>
                )}
            </div>
        </header>
    );
};

export default TopBar;
